import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ThirdPartyEvaluationFormItemFile } from '../../../models/thirdparty-evaluation-form-item-file';
import { AuthService } from '../../../core/auth/_services/auth.service';
import { FileService } from '../../../services/file.service';
import { saveAs } from 'file-saver';
import { ThirdPartyEvaluationFormAnswerFile } from '../../../models/thirdparty-evaluation-form-answer-file';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../../services/notification.service';
import { StringFormatPipe } from '../../../core/_base/layout/pipes/string-format.pipe';
import { FileDto } from '../../pages/thirdparties/tags/tags.service';
import { EvaluationFormItemType } from '@app/models/due-diligence/evaluation-form-item-type.table';

@Component({
  selector: 'kt-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit {
  // Set true to icon as SVG or false as icon class
  @Input() useSVG: boolean;
  // Set icon class name
  @Input() icon: string = 'flaticon2-clip-symbol';
  @Input() iconType: '' | 'success';

  @ViewChild('fileInput') fileInput: ElementRef = null;

  _answerId: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  // Id asociado al la respuesta de la evaluacion (no del template)
  @Input() set answerId(value) {
    this._answerId.next(value);
  };
  get answerId(): number {
    return this._answerId.getValue();
  }

  // Id associated: answerId or formId (del template)
  @Input() contextId: number;
  @Input() isDetail: boolean = false;

  @Output() fileUpload: EventEmitter<ThirdPartyEvaluationFormAnswerFile> = new EventEmitter();
  @Output() fileDequeue: EventEmitter<ThirdPartyEvaluationFormAnswerFile> = new EventEmitter();

  @Input() protectedMode: boolean = false;
  @Input() dueDiligenceMode: boolean = false;

  // Evaluation Files
  _evaluationFiles$: BehaviorSubject<any[]>;
  @Input() set evaluationFiles(value) {
    this._evaluationFiles$.next(value);
  };
  get evaluationFiles() {
    return this._evaluationFiles$.getValue();
  };

  // Preloaded FileIds
  @Input()
  initialFiles: ThirdPartyEvaluationFormItemFile[];

  @Input()
  fileDownloadFnc: (fileId: number) => Observable<any>;

  @Input()
  evaluationItemType: number;

  @Input()
  lastAnswerId: number;

  selectedFile: File;
  spinnerDisplay: boolean = false;

  dataSourceFilesCreate = new MatTableDataSource<ThirdPartyEvaluationFormItemFile>([]);

  user: any;
  private oneMB: number = 1048576; // 1 MB
  private maxSize: number = this.oneMB;

  filesQueue: number = 0;
  filesProcessed: number = 0;

  displayedFilesColumns: string[] = [
    'icon',
    'name',
    'type',
    'size'
  ];

  constructor(
    private _authService: AuthService,
    private _fileService: FileService,
    private translate: TranslateService,
    private notification: NotificationService,
    private stringFormat: StringFormatPipe
  ) {
    this._evaluationFiles$ = new BehaviorSubject<any[]>([]);
    this.maxSize = this._authService.maxUploadFileSize * this.oneMB;
  }

  ngOnInit() {
    this.initialFiles = this.initialFiles || [];

    this.dataSourceFilesCreate.data = this.initialFiles;

    // Cannot operate on files in protected mode
    if (!this.protectedMode) {
      this.displayedFilesColumns.push('action');
    }

    // Checkeo por los dos para evitar condiciones de carrera
    this._answerId.subscribe(x => {
      this.getPreloadedFiles()
    });
    this._evaluationFiles$.subscribe(x => {
      this.getPreloadedFiles()
    });

    this.user = this._authService.currentUserPublic;
    
  }

  ngOnChanges(){
    if(this.isDetail){
      let newFilesArr = [];
      console.log(this.initialFiles)
      this.initialFiles?.forEach(x => {
        if(newFilesArr.length == 0){
          newFilesArr.push(x);
        }else{
          if(!newFilesArr.find(f => f.id == x.id)){
            newFilesArr.push(x);
          }
        }
      });
      console.log(newFilesArr);
      this.initialFiles = newFilesArr;
      this.initialFiles = [...new Set(this.initialFiles)];
      this.dataSourceFilesCreate.data = this.initialFiles;
    }
    
    console.log(this.evaluationFiles)
    console.log(this.initialFiles)

    if(this.evaluationItemType && this.evaluationItemType == EvaluationFormItemType.List){
      console.log(this._answerId.getValue());
      // console.log(this._answerId.getValue());
      // console.log(this.evaluationFiles)
      if(!this.isDetail){
        // if(this.initialFiles?.length == 0 && this.evaluationFiles && this.evaluationFiles?.length > 0){
        //   this.evaluationFiles.forEach(x => {
            // if(x.thirdPartyEvaluationFormItemId == this._answerId.getValue()){
              // let newFile = new ThirdPartyEvaluationFormItemFile(x.file, x.createUser);
              // console.log(newFile);
              // console.log(this.initialFiles);
              // if(!this.initialFiles.find(f => f.id == newFile.id)){
              //   this.initialFiles.push(newFile);
              // }
            // }
        //   });
        // }
      }
    }
    console.log(this.initialFiles)
    this.dataSourceFilesCreate.data = this.initialFiles;
    console.log(this.dataSourceFilesCreate.data)
  }

  getPreloadedFiles() {
    if (!this.answerId || !this.evaluationFiles || !this.evaluationFiles.length)
      return;

    //Me quedo con los archivos para una respuesta dada
    let newFilesArr = [];
    newFilesArr = this.evaluationFiles
      .filter(x => x.thirdPartyEvaluationFormItemId == this.answerId)
      .map(x => new ThirdPartyEvaluationFormItemFile(x.file, x.createUser));
    // this.dataSourceFilesCreate.data = (this.initialFiles);

    newFilesArr?.forEach(x => {
      if(this.dataSourceFilesCreate.data.length == 0){
        this.dataSourceFilesCreate.data.push(x);
      }else{
        if(!this.dataSourceFilesCreate.data.find(f => f.id == x.id)){
          this.dataSourceFilesCreate.data.push(x);
        }
      }
    });

    
  }

  onFileUpload(files) {
    if (files && files.length > 0) {

      this.filesQueue += files.length;

      for (let index = 0; index < files.length; index++) {
        let selectedFile = files[index];

        // Verify allowed file extension
        if (!this._authService.allowedFileExtensions.includes(this.getFileExtension(selectedFile.name))) {
          this.filesProcessed++;
          this.showProcessedFiles();
          let msg = this.stringFormat.transform(this.translate.instant('FILEM.FILE_TYPE_NOT_SUPPORTED'), this.getFileExtension(selectedFile.name));
          this.notification.openSnackBar(msg);
        }
        // Verify Max file size
        else if (selectedFile.size >= this.maxSize) {
          this.filesProcessed++;
          this.showProcessedFiles();
          let msg = this.stringFormat.transform(this.translate.instant('FILEM.FILE_MAXSIZE'), selectedFile.name, this.formatBytes(this.maxSize));
          this.notification.openSnackBar(msg);
        }
        else {
          let reader = new FileReader();
          reader.readAsDataURL(selectedFile);
          reader.onload = () => {
            let newFile = new ThirdPartyEvaluationFormItemFile({
              id: 0,
              fileName: selectedFile.name,
              fileSize: selectedFile.size,
              file: (reader.result as string).split(',')[1],
              type: selectedFile.type
            });

            if (!newFile.file || newFile.file.length < 1) {
              this.filesProcessed++;
              this.showProcessedFiles();
              this.notification.openSnackBar(this.translate.instant('FILEM.FILE_EMPTY'));
            } else {
              this.postFileApi(newFile);
            }

          };
        }
      }
    } else {
      this.notification.openSnackBar(this.translate.instant('FILEM.NOFILE'));
    }

    if (this.fileInput && this.fileInput != undefined) {
      this.fileInput.nativeElement.value = null;
    }
  }

  showProcessedFiles() {
    if (this.filesQueue == this.filesProcessed) {
      this.clearFileUploadQueue();
    }
  }

  private clearFileUploadQueue() {
    this.filesQueue = this.filesProcessed = 0;
    this.spinnerDisplay = false;
  }

  getFileById(id, fileName) {
    if (id > 0) {
      this.spinnerDisplay = true;
      let apiRequest: Observable<any>;

      if (this.fileDownloadFnc) {
        apiRequest = this.fileDownloadFnc(id);
      } else {
        apiRequest = !this.dueDiligenceMode ?
          this._fileService.downloadFile(id, this.answerId) :
          this._fileService.downloadDueDiligenceRequestAnswerFile(id, this.answerId);
      }
      apiRequest.subscribe(res => {
        this.downloadFile(res, fileName, res.type);
        this.spinnerDisplay = false;
      },
        err => this.spinnerDisplay = false
      );
    }
  }

  downloadFile(data: any, fileName: string, fileType: string) {
    const blob = new Blob([data], { type: fileType });
    saveAs(blob, fileName);
  }

  postFileApi(file) {
    let itemAnswerId: number = null;

    this.spinnerDisplay = true;
    this._fileService.postFile(file).subscribe({
      next: response => {
        file.id = response;
        this.dataSourceFilesCreate.data.push(file);
        this.dataSourceFilesCreate._updateChangeSubscription();

        // Para preguntas simples
        if (!Array.isArray(this.contextId)) {
          itemAnswerId = this.contextId;
        }
        // Para con hijos, cada hijo es una respuesta no 'null'
        else if (this.contextId.length && this.contextId.every(x => x)) {
          itemAnswerId = this.contextId[0].parentId;
        
        }
        
        //Inform File uploades
        this.fileUpload.emit({
          FileId: file.id,
          appFormItemAnswerId: this.answerId //> 0 ? this.answerId : this.contextId//itemAnswerId//
        });

        this.filesProcessed++;
        this.showProcessedFiles();
      },
      error: err => {
        this.notification.openSnackBar(this.translate.instant('FILEM.ERROR'));
        this.clearFileUploadQueue();
      }
    })
  }

  //FileSize Format Func
  formatBytes(bytes) {
    const decimals = 2;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  dropFileCreate(file: ThirdPartyEvaluationFormItemFile) {
    this.dataSourceFilesCreate.data = this.dataSourceFilesCreate.data.filter(x => x.id != file.id);
    this.dataSourceFilesCreate._updateChangeSubscription();
    this.initialFiles = this.dataSourceFilesCreate.data;

    // Files are only deleted if relationship alerady file-answer exists
    if (file.createUser) {
      const apiRequest = !this.dueDiligenceMode ?
        this._fileService.deleteFile(file.id) :
        this._fileService.deleteRequestAnswerFile(file.id);

      apiRequest.subscribe(x => x);
    }

    //Inform File dequeue
    this.fileDequeue.emit({
      FileId: file.id,
      appFormItemAnswerId: this.contextId
    });
  }

  getFileExtension(fileName: string): string {
    if(fileName){
      const fileParts = fileName.split('.');
      return fileParts[fileParts.length - 1];
    }else{
      return '';
    }
  }

  getFileName(fileName: string): string {
    if(fileName){
      const fileParts = fileName?.split('.');
      return fileParts[0];
    }else{
      return '';
    }
  }

  featureEnabled() {
    //return Array.isArray(this.contextId)? this.contextId.length : this.contextId;
    if(this.isDetail){
      return true;
    }else{
      return this.contextId;
    }
  }

}
